// extracted by mini-css-extract-plugin
export default {"flowText":"ym1b6jfI3LUP2urROCPK"};